import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(7,23,48,0.58) 0%, rgba(8,33,66,0.48) 45%, rgba(10,40,80,0.36) 100%), linear-gradient(0deg, rgba(5,19,41,0.12), rgba(5,19,41,0.12)), url('/images/MillionaireHero.webp')",
          backgroundSize: 'cover, cover, cover',
          backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
          backgroundPosition: 'center, center, center'
        }}
      />

      <div className="relative z-20 max-w-[1240px] mx-auto px-5 md:px-8 lg:px-12 pt-9 md:pt-12 pb-7 md:pb-10">
        <div className="max-w-[760px] lg:max-w-[820px] mx-auto text-center">
          <div className="inline-block bg-[#d4a129] px-4 md:px-6 py-1.5 md:py-2">
            <p className="text-white font-[700] tracking-[0.14em] uppercase text-[20px] leading-none">
              Millionaire Makers:
            </p>
          </div>

          <h1 className="mt-3 md:mt-4 text-white font-[700] text-[30px] leading-[1.14] tracking-[0.01em]">
            The Life-Changing Potential of Resource Stocks
          </h1>

          <div className="mt-6 md:mt-9 text-white font-[500] text-[17px] leading-[1.35] tracking-[0.01em] space-y-4 md:space-y-5 max-w-[640px] mx-auto text-left">
            <p>
              Resource investing has changed my life. After a successful career on Bay Street as an equity analyst, I decided to
              get directly involved with mining companies.
            </p>
            <p>
              One of them, AbraSilver, delivered returns beyond my highest expectations… It changed my life and the lives
              of the people who invested alongside me.
            </p>
            <p>I will tell you the Abra story in a moment…</p>
            <p>
              For now, I want to focus on some of the most outstanding
              gains that the resource sector has delivered recently.
            </p>
          </div>
        </div>
      </div>

      <img
        src="/images/RobertBruggeman.webp"
        alt="Rob Bruggeman"
        className="relative z-10 mx-auto mt-2 md:mt-0 md:absolute md:right-[9%] md:bottom-0 w-[280px] sm:w-[320px] md:w-[420px] lg:w-[470px] h-auto object-contain"
      />
    </section>
  );
};

export default HeroSection;
